export const hardwareActions = [
  'Lock',
  'Headlight',
  'Taillight',
  'Throttle',
  'Saddle',
  'Tailbox',
  'Battery',
  'Restart',
  'Alarm',
  'Dock',
  'Cable Lock',
  'Speed Mode',
  'Seat',
]
